module.exports = __webpack_public_path__ + "static/media/gma1.bd0ad2d9.png";